import {ExpandingInputButton} from "@cjdev-internal/visual-stack-x/ExpandingInputButton";
import {useCampaignsContext} from "../CampaignsContext/useCampaignsContext";

const SearchPanel = ({api}) => {
    const {campaignsDataGridState, setCampaignsDataGridState} = useCampaignsContext();
    const onChangeHandler = (value) => {
        api.setQuickFilter(value);
        setCampaignsDataGridState(prevState => ({...prevState, quickFilterValue: value}));
    }
    return (
        <div id="globalSearch">
            <ExpandingInputButton startingValue={campaignsDataGridState.quickFilterValue} onChange={onChangeHandler}/>
        </div>
    );
};

export default SearchPanel;